import { apiRequest } from '@/core';
import {
  type SetCurrentEventPayload,
  type FetchEventPayload,
} from '@/slices/events/types';

export const fetchEventRequest = async ({ eventId }: FetchEventPayload) =>
  apiRequest<SetCurrentEventPayload>({
    endpoint: `api/events/event/${eventId}`,
  });
